import { tracked } from '@glimmer/tracking';

import FilterSortBoardFromAnotherSpaceAtSelectPopup from 'webapp/models-custom/filter-sort/board-from-another-space-at-select-popup';

export default class FilterSortBoardFromAnotherSpaceAtSelectPopupInList extends FilterSortBoardFromAnotherSpaceAtSelectPopup {
	@tracked override viewId = 'table';
	override itemDomSelector = '.filter-sort-item';
}
